<template>
  <div>
    <div class="content">
      <p v-if="errorMessage">{{ errorMessage }}</p>
      <ul>
        <li class="typeli" v-for="type in types" :key="type.title">
          <div class="sectionHeader">
            <div class="header" />
            <h3 class="title">{{ type.title }}</h3>
          </div>
          <ul>
            <li class="typeli" v-for="file in type.data" :key="file.title">
              <p @click="onClick(file.file_type, file)">{{ file.file_name }}</p>
            </li>
          </ul>
        </li>
      </ul>
      <div class="model" v-if="show">
        <div
          class="iframe"
          v-bind:style="{
            width: screenWidth + 'px',
            maxWidth: screenWidth + 'px',
          }"
        >
          <video-player
            v-if="playerOptions"
            ref="videoPlayer"
            :playsinline="true"
            :options="playerOptions"
            class="video-player"
          ></video-player>
          <iframe
            v-if="link_url"
            :src="link_url"
            :width="screenWidth"
            :height="iframeHeight"
            allowfullscreen="true"
          ></iframe>
        </div>
        <button class="button" @click="onClose">关闭</button>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import CryptoJS from 'crypto-js';
import BaseURL from '../static/config';

export default {
  name: 'FilesSource',
  data() {
    return {
      types: [],
      show: false,
      screenWidth: window.innerWidth,
      screenHeigth: 0,
      iframeHeight: 0,
      errorMessage: undefined,
      playerOptions: undefined,
      link_url: undefined,
    };
  },
  mounted() {
    const userInfoString = localStorage.getItem('bethel_userinfo');
    const dateString = localStorage.getItem('bethel_login_date');

    const userInfo = JSON.parse(
      CryptoJS.AES.decrypt(userInfoString, 'bethel_mobile_web_key').toString(
        CryptoJS.enc.Utf8
      )
    );

    const mIdBytes = CryptoJS.AES.decrypt(
      this.$route.query.mId,
      'bethel_mobile_web_key'
    );

    const mid = mIdBytes.toString(CryptoJS.enc.Utf8);

    if (
      !userInfoString ||
      !dateString ||
      userInfoString.length === 0 ||
      dateString.length === 0
    ) {
      this.$router.replace('/login');
    } else {
      const now = new Date().getTime();
      const date = Number(dateString);
      if ((now - date) / (60 * 60 * 24 * 1000) > 3) {
        this.$router.replace('/login');
      } else {
        axios
          .get(
            `${BaseURL}material_codes?user_id=${userInfo.user_id}&page=1&from_app=true`
          )
          .then((res) => {
            const foundItem = res.data.items.find(
              (i) => i.material_authentication._id === mid
            );
            if (!foundItem) {
              this.$router.replace('/login');
            }
          })
          .catch((error) => console.log('---------', error));
      }
    }

    this.screenWidth = window.innerWidth;
    this.screenHeigth = window.innerHeight;
    this.iframeHeight = window.innerHeight - 100;

    axios
      .get(
        `${BaseURL}material_authentications/${mid}`,
        {},
        {
          headers: {
            'Content-Type': 'application/json',
          },
        }
      )
      .then((res) => {
        this.types = [
          {
            type: 'scource',
            title: '资源',
            data: res.data.file_sources,
          },
        ];
      });
  },
  methods: {
    onClick(type, file) {
      this.show = true;
      if (type === 0 || file.file_type === 4) {
        // this.link_url = undefined;
        // this.playerOptions = {
        //   muted: false,
        //   playbackRates: [0.7, 1.0, 1.5, 2.0],
        //   sources: [
        //     {
        //       type: 'video/mp4',
        //       src: file.file_url,
        //     },
        //   ],
        // };

        this.link_url = `http://app.ourbethel.cn:8082/#/video_player?screenWidth=${window.innerWidth}&videoId=${file.file_url}`;
      } else if (
        type === 'pdf' ||
        type === 'ppt' ||
        type === 'url' ||
        file.file_type === 3 ||
        file.file_type === 2
      ) {
        this.playerOptions = undefined;
        this.link_url = file.file_url;
      }
    },
    onClose() {
      this.show = false;
    },
  },
};
</script>

<style scoped>
li {
  padding: 10px 0px;
  text-align: left;
}

.model {
  position: fixed;
  top: 0px;
  right: 0px;
  bottom: 0px;
  left: 0px;
  background-color: white;
  display: flex;
  justify-items: center;
  align-items: center;
  flex-direction: column;
}

.typeli {
  list-style: none;
}

.header {
  background-color: red;
  margin-right: 10px;
  display: inline-block;
  width: 10px;
  height: 20px;
}

.sectionHeader {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.button {
  height: 40px;
  width: 320px;
  border-radius: 20px;
  outline: none;
  border: #d5d5d5 1px solid;
  margin-top: 20px;
  background-color: #49afad;
  color: white;
  font-size: 14;
}
.content {
  display: flex;
  background-color: #f7f7f7;
  width: 100vw;
  justify-content: center;
  align-items: center;
}

.video-player >>> .vjs_video_3-dimensions {
  width: 1053px !important;
  height: 540px !important;
}

.iframe {
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
